import useGetAllClientsMarketsInfinite from '@/hooks/query/useGetAllClientsMarketsInfinite'
import { Link, createFileRoute } from '@tanstack/react-router'
import { Fragment } from 'react/jsx-runtime'

import Breadcrumbs from '@/containers/breadcrumbs'

import { Button } from '@/components/button'
import { Card } from '@/components/card'
import Content from '@/components/content'
import LoadMoreButton from '@/components/loadMoreButton'
import PageHeader from '@/components/pageHeader'
import Spinner from '@/components/spinner'
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/table'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'
import { useMarketFilter } from '@/state/marketFilter'

import MarketRow from './-components/marketRow'
import MarketTableFilter from './-components/marketTableFilter'

export const Route = createFileRoute('/_authed/$client_code/markets/')({
    component: Markets,
})

function Markets() {
    const { client_code } = Route.useParams()
    const marketFilter = useMarketFilter(client_code)
    const {
        data: markets,
        isLoading,
        hasNextPage,
        fetchNextPage,
    } = useGetAllClientsMarketsInfinite(client_code, marketFilter.includeDeleted)
    useSetBreadcrumbs([
        {
            to: '/$client_code/markets',
            text: 'Markets',
            params: { client_code },
        },
    ])

    if (isLoading) {
        return <Spinner size="sm" absolute navVisible />
    }

    if (!markets) {
        return <p>Hmmm</p>
    }

    const normalisedFilterText = (marketFilter.filterText || '').toLowerCase()
    const filteredData = normalisedFilterText.length
        ? markets?.filter(
              market =>
                  market.code.toLowerCase().includes(normalisedFilterText) ||
                  market.name.toLowerCase().toLowerCase().includes(normalisedFilterText),
          )
        : markets

    return (
        <>
            <Breadcrumbs />
            <Content>
                <PageHeader
                    title="Markets"
                    controls={
                        <Link to={`/$client_code/markets/create`} params={{ client_code }}>
                            <Button variant={'outline'} className="mb-2">
                                Create
                            </Button>
                        </Link>
                    }
                />

                <Card hideOverflow>
                    <Table>
                        <TableHeader asCard>
                            <MarketTableFilter clientCode={client_code} />
                            <TableRow>
                                <TableHead>Code</TableHead>
                                <TableHead>Type</TableHead>
                                <TableHead>Name</TableHead>
                                <TableHead>Timezone</TableHead>
                                <TableHead>State</TableHead>
                                <TableHead />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {filteredData?.map((market, idx) => (
                                <Fragment key={market?.code || idx}>
                                    {market && <MarketRow key={market.code} market={market} />}
                                </Fragment>
                            ))}
                        </TableBody>
                    </Table>
                    <div className="flex justify-center">
                        <LoadMoreButton
                            className="my-4"
                            fetchNextPage={fetchNextPage}
                            isLoading={isLoading}
                            hasNextPage={hasNextPage}
                        />
                    </div>
                </Card>
            </Content>
        </>
    )
}
